import React from 'react';

interface EmptyStateProps {
  onShowShortcuts: () => void;
}

export default class EmptyState extends React.Component<EmptyStateProps> {
  render() {
    const { onShowShortcuts } = this.props;

    return (
      <div className="empty-state">
        <div className="empty-state-content">
          <span className="empty-state-icon">✨</span>
          <h2>Start Creating</h2>
          <p>Draw on canvas to create your first animation frame</p>
          <button onClick={onShowShortcuts} className="shortcuts-button">
            View Keyboard Shortcuts
          </button>
        </div>
      </div>
    );
  }
}
